import {
  AssetFillState,
  AssetStatus,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const updateAssetMutationAtom = createMutationAtomFactory(
  'transportation.assetUpdate',
  (params: {
    id: string;
    status?: AssetStatus | null;
    fillState?: AssetFillState | null;
    identifier?: string | null;
    description?: string | null;
    notes?: string | null;
    accountId?: string | null;
    facilityId?: string | null;
    accountAddressId?: string | null;
    tareWeight?: WeightInput | null;
    customAttributes?: Record<string, unknown> | null;
  }) => {
    const { id, ...input } = params;
    return {
      transportationAssetUpdate: {
        __args: {
          id,
          input,
        },
        id: true,
      },
    };
  },
);
